import React, { useEffect, useRef } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import Chart from "chart.js/auto";

const PaymentDistributionChart = ({ paymentData }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      // Destroy existing chart
      chartInstance.current?.destroy();

      const ctx = chartRef.current.getContext("2d");
      const paymentTypes = ["Cash", "Card", "Online", "Bank"];
      const paymentAmounts = [
        paymentData.cashPaymentAmount,
        paymentData.cardPaymentAmount,
        paymentData.onlinePaymentAmount,
        paymentData.bankPaymentAmount,
      ];

      chartInstance.current = new Chart(ctx, {
        type: "pie",
        data: {
          labels: paymentTypes,
          datasets: [
            {
              data: paymentAmounts,
              backgroundColor: [
                "rgba(75, 192, 192, 0.6)",
                "rgba(54, 162, 235, 0.6)",
                "rgba(255, 206, 86, 0.6)",
                "rgba(255, 99, 132, 0.6)",
              ],
              borderColor: [
                "rgba(75, 192, 192, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(255, 99, 132, 1)",
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                boxWidth: 15,
                padding: 10,
              },
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const value = context.parsed;
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const percentage = ((value / total) * 100).toFixed(2);
                  return `NRS. ${value.toLocaleString()} (${percentage}%)`;
                },
              },
            },
          },
          layout: { padding: 10 },
        },
      });
    }

    return () => chartInstance.current?.destroy();
  }, [paymentData]);

  return (
    <Card className="shadow-sm">
      <CardBody className="p-3">
        <CardTitle tag="h5" className="text-center mb-2">
          Payment Distribution
        </CardTitle>
        <div style={{ height: "310px", width: "100%" }}>
          <canvas ref={chartRef} />
        </div>
        <div className="text-center mt-2">
          <small>
            Total Payment: NPR.{" "}
            {(paymentData.totalPaymentAmount || 0).toLocaleString()}
            {" | "}
            Total Transactions: {paymentData.totalPaymentCount || 0}
          </small>
        </div>
      </CardBody>
    </Card>
  );
};

export default PaymentDistributionChart;
